var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { RoleEnum } from "../types/RoleEnum";
import { readServerErrors } from "./serverErrorUtils";
/** Status of PublisherEdit when a publisher user edits their own publisher ("Můj nakladatel"). */
export var MY_PUBLISHER_STATUS = "MY_PUBLISHER";
/** Roles that may change the guarantors even when they also hold PublisherGuarantor. */
var GUARANTOR_MANAGING_ROLES = [
    RoleEnum.PUBLISHER_ADMIN,
    RoleEnum.AGENCY_WORKER,
    RoleEnum.SUPERUSER,
];
/**
 * Whether the guarantors block (edit, add, remove, roles) is read-only: only in the "Můj nakladatel" editor and
 * only for a user who is ONLY a plain PublisherGuarantor - a publisher admin (also a legacy dual-role one), the
 * agency and a superuser keep it editable. The backend enforces the same rule (403 GUARANTORS_CHANGE_FORBIDDEN).
 *
 * @param status the PublisherEdit status
 * @param activeRoles the user's active roles (undefined while still loading)
 * @returns true when the guarantors must not be changed by this user
 */
export var isPlainGuarantorInMyPublisher = function (status, activeRoles) {
    return status === MY_PUBLISHER_STATUS &&
        Array.isArray(activeRoles) &&
        activeRoles.includes(RoleEnum.PUBLISHER_GUARANTOR) &&
        !activeRoles.some(function (role) { return GUARANTOR_MANAGING_ROLES.includes(role); });
};
/** Error type / code of the backend refusing a guarantor change by a plain guarantor (DB-876). */
var GUARANTORS_CHANGE_FORBIDDEN_TYPE = "-18";
var GUARANTORS_CHANGE_FORBIDDEN_CODE = "GUARANTORS_CHANGE_FORBIDDEN";
/**
 * Whether a failed save was the backend refusing a guarantor change (HTTP 403 GUARANTORS_CHANGE_FORBIDDEN).
 *
 * @param error the error thrown by the ky client
 * @returns true for that refusal
 */
export var isGuarantorsChangeForbiddenError = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var status;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                status = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status;
                if (status !== 403)
                    return [2 /*return*/, false];
                return [4 /*yield*/, readServerErrors(error)];
            case 1: return [2 /*return*/, (_b.sent()).some(function (item) {
                    return item.type === GUARANTORS_CHANGE_FORBIDDEN_TYPE ||
                        item.code === GUARANTORS_CHANGE_FORBIDDEN_CODE;
                })];
        }
    });
}); };
